import * as yup from 'yup'
import { emailRegex } from 'utils/emailRegex'

export const EMAIL_NOT_FOUND_MESSAGE =
  "We couldn't find an account with this email address at your school. You can only add instructors with Second Step® accounts at your school."

export const EMAIL_INACTIVE_MESSAGE =
  'This user has been added to your school but has not yet created their Second Step® account. They must create an account before they can be added to a class.'

export const addInstructorEmailSchema = yup.object().shape({
  email: yup
    .string()
    .default('')
    .max(256, 'Please enter 256 characters or less')
    .trim()
    .required('Please enter an email address')
    .test('email', function(value) {
      if (!value) return true // Let required() handle empty values
      const isValidEmail = emailRegex.test(value)

      if (!isValidEmail) {
        const missingParts = []
        const [localPart, domainPart] = value.split('@')

        if (!localPart) {
          missingParts.push(`missing username portion in before "@"`)
        }
        if (!domainPart) {
          missingParts.push(`missing domain portion in after "@"`)
        } else {
          const domainParts = domainPart.split('.')
          if (domainParts.length < 2 || !domainParts[1]) {
            missingParts.push('missing domain extension after "." in domain')
          }
        }

        if (!value.includes('@')) {
          missingParts.push('missing "@" symbol')
        }
        return this.createError({
          message: `Invalid email address in '${value}': 
            ${missingParts.join(', ')}`,
        })
      }
      return true
    }),
})
